<template>
  <div class="sp-sort-button-group display-inline-block">
    <sort-button dir="up"   :disabled="!canUp"   @click="$emit('up')" />
    <sort-button dir="down" :disabled="!canDown" @click="$emit('down')" />
  </div>
</template>

<script>
import SortButton from "@/components/common/sort-button/SortButton";
export default {
  name: "SortButtonGroup",
  components: { SortButton },
  props: {
    canUp: {
      type: Boolean,
      default: true
    },
    canDown: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style scoped>
.sp-sort-button-group > :first-child {
  margin-right: 4px;
}
</style>
